import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Blog5D() {
  const [loading, setLoading] = useState(false);
   const [showSuccessModal, setShowSuccessModal] = useState(false);
            const [formType, setFormType] = useState(""); // stores which button opened the form
        const [contactForm, setContactForm] = useState({
          fullname: "",
          company: "",
          website: "",
          email: "",
          phone: "",
          message: "",
        });
        const handleContactChange = (e) => {
          const { name, value } = e.target;
          setContactForm((prev) => ({ ...prev, [name]: value }));
        };
        
        
        const isBusinessEmail = (email) => {
          const freeDomains = [
            "gmail.com",
            "yahoo.com",
            "hotmail.com",
            "outlook.com",
            "aol.com",
            "icloud.com",
            "mail.com",
            "live.com"
          ];
          const domain = email.split("@")[1]?.toLowerCase();
          if (!domain) return false;
          return !freeDomains.includes(domain);
        };
        
        
        const handleContactSubmit = async (e) => {
          e.preventDefault();
         
          setLoading(true); // show loading message
          const { fullname, company, website, email, phone, message } = contactForm;
        
        
          // Basic validation
          if (!fullname || !email || !message || !company || !phone) {
            alert("Please fill all required fields.");
              setLoading(false); // show loading message
        
            return;
          }
        if (!isBusinessEmail(email)) {
            alert("Please enter a business email, not Gmail/Yahoo/etc.");
              setLoading(false); // show loading message
        
            return;
          }
         
        
          try {
              try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
            const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

            });
        
            if (response.ok) {
               setShowSuccessModal(true);  // ✅ This triggers modal to open
               setLoading(false); // show loading message
               setContactForm({
                fullname: "",
                company: "",
                website: "",
                email: "",
                phone: "",
                message: "",
              });
            } else {
              alert("Error sending message.");
            }
          } catch (err) {
            console.error(err);
            alert("Error sending message.");
          }
        };
  return (
    <div>
      <Header />
      <main>
           <AnimatePresence>
                          {showSuccessModal && (
                            <motion.div
                              className="modal-overlay show"
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              exit={{ opacity: 0 }}
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                background: "rgba(0,0,0,0.5)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 9999,
                              }}
                            >
                              <motion.div
                                className="modal show"
                                initial={{ scale: 0.8, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                exit={{ scale: 0.8, opacity: 0 }}
                                transition={{ duration: 0.3 }}
                                style={{
                                  background: "#fff",
                                  padding: "30px",
                                  borderRadius: "10px",
                                  width: "400px",
                                  textAlign: "center",
                                  boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                                }}
                              >
                                <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                                  Message Sent!
                                </h2>
                                <p>Thank you for contacting us. We will get back to you shortly.</p>
                                <button className="vc rg lk gh ml il hi gi _l"
                                  onClick={() => setShowSuccessModal(false)}
                                 
                                >
                                  Close
                                </button>
                              </motion.div>
                            </motion.div>
                          )}
                        </AnimatePresence>
        {/* 🔹 FAQ Section */}
        <section className="i ji ii db">
        
      <div className="bb ze ki xn 2xl:ud-px-0">
        <div className="tc sf yo zf kq">
          <div className="ro1">
            <div className="animate_top rounded-md shadow-solid-13 bg-white dark:bg-blacksection border border-stroke dark:border-strokedark p-7.5 md:p-10">
             
              <div className="container">
               <div className="left">
          <img src="../images/blogim5.png" className="vd" alt="Blog" />
        </div>
          <div className="right">
<h2 className="ek vj 2xl:ud-text-title-lg kk wm nb gb mk">
               How Intent Data is Revolutionizing B2B Demand Generation in Fintech
              </h2>
                <ul className="tc uf cg 2xl:ud-gap-15 fb">
                <li>
                  <span className="rc kk wm">Published On: </span> Oct 16, 2025
                </li>
                  <li>
                   <span className="rc kk wm">Published by:</span> Pinakinedge Media
                </li>
              </ul>
          </div>
            </div>
           <br/>
                <p className="jutfy">
In B2B fintech, where competition is fierce and sales cycles are complex, generating high-quality demand isn’t just about volume—it’s about relevance and timing.<br/>
<br/>
Today, traditional lead lists and demographic targeting are no longer enough. Financial decision-makers—whether banks, lenders, or enterprise CFOs—are doing most of their research long before ever talking to a sales rep. That’s where intent data comes in.
<br/>
<br/>
By capturing and analyzing real-time digital signals that reveal what buyers are actively researching, intent data has become the foundation of modern B2B demand generation in fintech. It enables marketers to identify which businesses are “in-market” for their solutions and empowers sales teams to engage with them at precisely the right moment.
</p>
              <p className="mb bgimh">
                What Is Intent Data in the B2B Fintech Context?
              </p>
             
 <p className="jutfy">
  In B2B demand generation, intent data refers to behavioral information that signals a company’s potential interest in a product or service. It’s derived from digital activities such as:
 </p>
              
              <ul className="jutfy">
                <li>•	Visiting relevant industry websites</li>
<li>•	Downloading whitepapers or case studies</li>
<li>•	Searching for competitor comparisons</li>
<li>•	Engaging with thought leadership content</li>
<li>•	Attending webinars or conferences on related topics

</li>
              </ul>

                <p className="jutfy">
                  In fintech, these signals might indicate when a bank is evaluating new fraud detection software, when a lender is comparing credit risk analytics tools, or when a payments company is exploring API security solutions.
                  <br/>
                  Intent data can be first-party (from your owned channels like your website, emails, or app) or third-party (collected from external sites and content platforms). When combined, they create a full picture of your target accounts’ buying journey.
              </p>
              <p className="mb bgimh">
          Why Intent Data Is a Game-Changer for B2B Fintech Demand Generation
          <br/>
          <br/>
          1. Moving from Cold Outreach to Warm Engagement
              </p>
               <p className="jutfy">
              Traditional demand generation relies on assumptions—targeting based on firmographics (company size, industry, region) and hoping for interest. Intent data flips that model.
              <br/>
              By identifying companies that are actively showing interest in fintech solutions similar to yours, marketing teams can build audiences of high-probability prospects. This allows sales to move away from cold calls and focus on warm, research-driven conversations.
              <br/>
              For example, if a mid-size digital bank is consuming content around “AI-driven credit scoring,” your team can engage them with tailored content highlighting how your solution addresses that specific need.
              </p>
              
             <p className="mb bgimh">
              The result: shorter sales cycles, improved response rates, and higher ROI on marketing spend.</p>
            
               <p className="mb bgimh">
       2. Powering Account-Based Marketing (ABM)
              </p>
              <p className="jutfy">
               Intent data and ABM (Account-Based Marketing) go hand in hand—especially in fintech, where deals are often high-value and decision-making involves multiple stakeholders.
               <br/>
               Intent signals help you prioritize and personalize ABM efforts. By tracking which target accounts are actively researching topics related to your solutions, marketing teams can:
               </p>
               <ul className="jutfy">
                <li>•	Focus campaigns on accounts that are “heating up”</li>
<li>•	Deliver hyper-relevant messaging to different buyer personas (e.g., risk, compliance, IT, or finance leaders)</li>
<li>•	Align outreach between marketing and sales with unified, data-driven intelligence

</li>
               </ul>
            
              <p className="jutfy">
For instance, if your fintech SaaS offers regulatory compliance automation, and you see spikes in intent around “digital KYC” or “AML tools,” that’s your cue to activate ABM campaigns focused on compliance officers in those organizations.
              </p>

              <p className="mb bgimh">
            3. Enhancing Lead Scoring and Qualification
              </p>
               <p className="jutfy">
             In fintech demand generation, not every lead is created equal. Many companies collect thousands of leads, but few convert because they aren’t truly ready to buy.
             <br/>
             Intent data brings precision to lead scoring by layering behavioral insights on top of demographic and firmographic data.
             <br/>
             A lead that fits your ICP (Ideal Customer Profile) and shows increasing engagement with relevant content—like whitepapers on “cross-border payment APIs” or “AI-based fraud detection”—should be prioritized for nurturing or direct outreach.
             <br/>
             This ensures marketing and sales teams are aligned around the right accounts at the right time, improving both conversion and efficiency.
               </p>

                 <p className="mb bgimh">
         4. Creating Hyper-Personalized Content Journeys
              </p>
               <p className="jutfy">
                B2B fintech buyers crave relevance. They don’t want generic marketing—they want insights tailored to their pain points and business goals. Intent data enables you to deliver that.
                <br/>
                By analyzing the topics and keywords your target audience is engaging with, you can craft personalized content experiences that speak directly to their challenges.
                <br/>
                For example:
              </p>
              <ul className="jutfy">
                <li>
                  •	A CFO searching for “real-time cash flow forecasting” could receive a custom guide on “Predictive Treasury Management.”
                </li>
  <li>•	A compliance leader showing intent around “open banking security” could get invited to a webinar on “Data Privacy in Open Banking Ecosystems.”

                </li>
              </ul>
               <p className="jutfy">
            Personalization driven by intent data doesn’t just improve engagement—it positions your fintech brand as a trusted advisor in the buying process.
              </p>
              <p className="mb bgimh">
          5. Shortening Complex B2B Sales Cycles
              </p>
               <p className="jutfy">
               Fintech deals often involve lengthy decision-making processes with multiple stakeholders—from compliance officers to IT directors and procurement teams. Intent data helps identify where each stakeholder is in the buying journey, allowing marketing and sales teams to tailor their approach accordingly.
               <br/>
               If intent data shows consistent engagement across multiple personas within one account, that’s a strong buying signal. It’s time to involve senior sales reps, prepare case studies, and guide the account toward conversion.
               <br/>
               By acting on these early signals, fintech providers can move deals faster through the pipeline and forecast revenue more accurately.
              </p>
            
                 <p className="mb bgimh">
        6. Improving Marketing and Sales Alignment
              </p>
               <p className="jutfy">
             One of the biggest challenges in B2B fintech demand generation is the misalignment between marketing and sales. Marketing generates leads, but sales often complains they’re not qualified. Intent data bridges that gap.
             <br/>
             When both teams have access to the same real-time intent insights, they can collaborate on strategy

              </p>
               <ul className="jutfy">
              <li>•	Marketing can prioritize campaigns around active accounts.</li>
<li>•	Sales can personalize outreach using contextual insights (like what topics an account is researching).</li>
<li>•	Both can measure success using shared metrics tied to intent-driven engagement.
</li>
              </ul>
              <p className="jutfy">
                This unified approach improves pipeline velocity and fosters stronger collaboration across departments.
              </p>
            
              <p className="mb bgimh">
     Best Practices for Using Intent Data in Fintech Demand Generation
              </p>
               <ul className="jutfy">
                <li>•	Combine First-Party and Third-Party Data: Integrate your CRM, marketing automation, and external intent platforms to get a complete view of account activity.</li>
 <li>•	Use AI and Predictive Analytics: Employ machine learning to identify trends, score intent, and trigger automated outreach.</li>
 <li>•	Prioritize Data Compliance: Ensure adherence to GDPR, CCPA, and financial data privacy standards. Ethical data usage builds long-term trust.</li>
 <li>•	Align Sales and Marketing Cadences: Create shared dashboards so both teams can see which accounts are surging in intent.</li>
 <li>•	Continuously Optimize Campaigns: Use intent signals to refine content, targeting, and channel strategy for maximum performance.
</li>
              </ul>
             <p className="mb bgimh">
                Conclusion: The Future of B2B Fintech Demand Generation Is Intent-Driven
              </p>
              <p className="jutfy">
                In B2B fintech, winning attention and trust requires more than good messaging—it requires timing, relevance, and insight. Intent data delivers all three.
                <br/>
                By understanding not just who your buyers are but what they’re actively seeking, fintech marketers can transform demand generation from a guessing game into a precise, predictive science.
                <br/>
                The companies that embrace intent data today will be tomorrow’s market leaders—driving smarter pipelines, deeper engagement, and measurable growth in an industry defined by data.
              </p>
               <p className="mb bgimh">Ready to turn insights into qualified demand? Let’s talk about how intent data can power your fintech growth.</p>
              <div className="animate_top w-full nn/5 vo/3 vk sg hh sm yh tq">
       <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="fullname">Full name</label>
      <input
        type="text"
        name="fullname"
        id="fullname"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="company">Company</label>
      <input
        type="text"
        name="company"
        id="company"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="website">Phone number</label>
        <input
  type="text"
  name="phone"
  id="phone"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="email">Email address</label>
      <input
        type="email"
        name="email"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>
  <div className="fb">
    <label className="rc" htmlFor="message">Comment</label>
    <textarea
      placeholder="Comment"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
  onClick={() => {
    setFormType("Blog: How Intent Data is Revolutionizing B2B Demand Generation in Fintech");
  }}
>
  {loading ? "Please wait..." : " Post Comment"}
</button>
  </div>
</form>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
       
      </main>
      <Footer />
    </div>
  );
}

export default Blog5D;
